<template>
   <span light>
    <v-content>
      <section id="frs_parallax">
        
        <v-parallax src="/static/img/home_background.jpg" style="height: 100vh;">
          <v-layout
            column
            align-center
            justify-center
            class="white--text"
          >
          <span style="cursor: pointer" title="Motor Fiscal" @click="$router.push('/')">
            <img src="@/assets/images/logo_transparente/ico2.png" alt="Logo motor" height="100" style="margin-left: 16px;">
            <h1 class="white--text mb-4 display-1 text-xs-center" style="color: #00aea7!important;font-weight: 500; font-size: 44px!important;"><span style="color:white; font-weight: 800;letter-spacing: 2px!important;">M</span>otor Fiscal</h1>
          </span>
            <v-btn
              class="teal"
              dark
              large
              href="/cadastrar"
            >
              Conhecer
            </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section >
        <v-layout
          column
          wrap
          class="my-5"
          align-center
        >
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline">A melhor maneira de organização fiscal</h2>
              <span class="subheading">
                Tenha acesso a tudo em um único ambiente
              </span>
            </div>
          </v-flex>
          <v-flex xs12 >
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--lighten-2">color_lens</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Fácil utilização</div>
                    </v-card-title>
                    <v-card-text>
                      Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. 
                      Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                      Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. 
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--lighten-2">flash_on</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Rápido acesso</div>
                    </v-card-title>
                    <v-card-text>
                      Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. 
                      Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                      Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. 
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--lighten-2">build</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Organização fiscal</div>
                    </v-card-title>
                    <v-card-text>
                      Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. 
                      Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                      Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. 
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section id="snd_parallax">
        <v-parallax src="/static/img/home_background_engrenagens.jpg" height="380">
          <v-layout column align-center justify-center>
            <div class="headline white--text mb-3 text-xs-center">Começe agora e armazene seus documentos fiscais no <strong>Motor Fiscal</strong></div>
            <em style="color: lightslategray;">Teste agora!</em>
            <v-btn
              class="teal"
              dark
              large
              href="/cadastrar"
            >
              Conhecer
            </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Compila</div>
                </v-card-title>
                <v-card-text>
                  Com 10 anos de atuação no mercado visando oferecer tecnologia de ponta 
                  com o objetivo de alavancar os negócios das empresas,
                  com o passar do tempo identificamos a necessidade de atender um nicho de empresas mais
                  robusto como grandes corporações e multinacionais e hoje atendemos empresas de todos os portes,
                  sempre com um atendimento personalizado e utilizando as melhores ferramentas do mercado.
                  <br><strong><a class="black--text" href="http://www.compila.com.br" target="_blank">Visitar site</a></strong>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 offset-sm1>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Entre em contato</div>
                </v-card-title>
                <v-card-text>
                  Estamos dispostos a sanar todas as dúvidas.
                </v-card-text>
                <v-list class="transparent">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>+55 (11) 4306-3036</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">place</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Av. Paulista, 2006 - 6 Andar</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">email</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>contato@compila.com.br</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <v-footer style="background-color: #25476a!important">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <div class="white--text ml-3">
              Mais um produto
              <v-icon class="red--text">favorite</v-icon>
              <a class="white--text" href="http://www.compila.com.br" target="_blank" style="text-decoration:underline">Compila</a>
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>
  </span>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/guestArea/home/Home.vue